<div
  class="relative flex flex-col items-center justify-center p-4 space-y-2 border rounded h-44 fled w-72 border-project-4100 contrast-50 hover:brightness-105 hover:contrast-100"
>
  <ng-content></ng-content>
  <img data-testid="thumbnailImage" class="w-auto h-2/3" [src]="media?.inlineUrl" [alt]="media?.name" />
  <div
    class="flex flex-col w-full pt-1 space-y-1 border-t border-x-project-100 overflow-ellipsis"
  >
    <span
      class="overflow-hidden text-ellipsis whitespace-nowrap"
      [matTooltip]="media?.name"
      data-testid="mediaName"
      >{{ media?.name }}</span
    >
    <span
      ><a
        *ngIf="!media.canUseInArticle"
        class="m-flag"
        ng-href="mailto:picturedesk@citywire.co.uk?subject=Image Unlock request for {{
          media?.name
        }}&amp;body=Image Name: {{ media?.name }}%0D%0A%0D%0ACMS link: {{
          media?.id
        }}&amp;resetSelectionService=1&amp;searchString=%0D%0A%0D%0AImage lock reason: it is locked"
        href="mailto:picturedesk@citywire.co.uk?subject=Image Unlock request for {{
          media?.name
        }}&amp;body=Image Name: {{ media?.name }}%0D%0A%0D%0ACMS link: {{
          cmsUrl
        }}/#/images/detail?imageIdentifier={{
          media?.id
        }}&amp;resetSelectionService=1&amp;searchString=%0D%0A%0D%0AImage lock reason: it is locked"
        data-testid="contactPictureDeskLink"
        >Contact Picturedesk</a
      >
    </span>
    <span data-testid="mediaUploadedDate">{{ media?.uploadedDate | date : "MMM d, yyyy HH:mm" }}</span>
  </div>
</div>
